export default "__VITE_ASSET__etz5CPmm__"